import React from "react";
import "../styles/AboutSection.css";
import AboutImage from "../images/about-mango.jpg"; // replace with your image

const AboutSection = () => {
  return (
    <section className="about-section">
      {/* Background oversized text */}
      <div className="about-bg-text">ABOUT</div>

      <div className="about-content">
        {/* Left text */}
        <div className="about-text left">
          <p>
            Mango is built for modern personal finance — simple, intentional,
            and designed to help you understand your money without the noise.
          </p>
        </div>

        {/* Center image */}
        <div className="about-image-wrapper">
          <img src={AboutImage} alt="About Mango" />
        </div>

        {/* Right text */}
        <div className="about-text right">
          <p>
            Track expenses, plan goals, and gain clarity across your financial
            life — all in one beautifully crafted experience.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
